// import external dependencies
import 'custom-event-polyfill'
import 'jquery'
import 'chosen-js'
import * as moment from 'moment'
import AOS from 'aos'

// Import everything from autoload


// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs
})

// Load Events
jQuery(document).ready(() => routes.loadEvents())

// Menu animation
$('#menu-button').on('click', function () {
  $('#navbarMenu').removeClass('pristine')
  $('#navbarMenu').toggleClass('is-active')
  $('#navbar').removeClass('pristine')
  $('#navbar').toggleClass('is-open')
})

// Custom EU4ENV.
jQuery(document).ready(() => {
  AOS.init()

  // Header search.
  $('#header-search-button').on('click', () => {
    $('#search-container').removeClass('hidden')
    $('#header-search-input').focus()
  })
  $('#search-close-button').on('click', () => {
    $('#header-search-input').val('')
    $('#search-container').addClass('hidden')
  })
  $('#header-search-input').on('keyup', (e) => {
    if (e.keyCode === 13) {
      window.location.href = '/?s=' + $('#header-search-input').val()
    }
  })

  // Home slider animation.
  const slideCount = $('.slide').length
  let activeSlideIndex = 0
  updateActiveSlide(activeSlideIndex)

  function updateActiveSlide(index) {
    $('.slide').removeClass('is-active')
    $('.slide-index-' + index).addClass('is-active')
  }

  $('.carousel--main-control-prev').on('click', function () {
    activeSlideIndex = activeSlideIndex - 1
    if (activeSlideIndex < 0) {
      activeSlideIndex = slideCount - 1
    }
    updateActiveSlide(activeSlideIndex)
  })

  $('.carousel--main-control-next').on('click', function () {
    activeSlideIndex = activeSlideIndex + 1
    if (activeSlideIndex > slideCount - 1) {
      activeSlideIndex = 0
    }
    updateActiveSlide(activeSlideIndex)
  })
  // Set interval for automatic slide change.
  setInterval(function () {
    activeSlideIndex = activeSlideIndex + 1
    if (activeSlideIndex > slideCount - 1) {
      activeSlideIndex = 0
    }
    updateActiveSlide(activeSlideIndex)
  }, 10000)

  // Chosen plugin multi-selects.
  $('.chosen-select').chosen({
    disable_search_threshold: 10,
    max_selected_options: 99
  })

  $('.reload-filter').on('change', function () {
    var locationHref = window.location.href

    // Go to first page if we change params.
    if (locationHref.indexOf('/page/') !== -1) {
      locationHref = locationHref.split('/page/')[0]
    }

    var url = new URL(locationHref)

    if ($(this).val()) {
      url.searchParams.set(this.name, $(this).val())
    } else {
      url.searchParams.delete(this.name)
    }
    window.location.href = url.href
  })

  // Get all years from 2019.
  var years = []
  var startDate = moment('2019-01-01')
  var endDate = moment()
  while (startDate.isBefore(endDate)) {
    years.push(startDate.format('YYYY'))
    startDate = startDate.add(1, 'year')
  }

  $.each(years, function (i, item) {
    $('#year-select').append(
      $('<option>', {
        value: item,
        text: item
      })
    )
  })

  // Set filters based on URL params.
  $('.reload-filter').each(function () {
    var param = getUrlParameter(this.name)

    if (param) {
      const selectedValues = param.split(',')
      $(this).val(selectedValues).trigger('chosen:updated')
    }
  })

  // JS links.
  $('.js-link').on('click', function () {
    window.open($(this).data('url'), '_blank')
  })

  // Mobile menu dropdown
  $('.js-toggle-mobile-dropdown').on('click', function () {
    $('.navbar-dropdown').removeClass('is-open-mobile')
    $(this).children('.navbar-dropdown').addClass('is-open-mobile')
  })

  // Helpers
  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=')

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1])
      }
    }
  }
})



// WEBPACK FOOTER //
// ./scripts/main.js